var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"printable-reward-link-redemption-header"},[_c('printable-reward-link-redemption-header-logo',{attrs:{"url":_vm.urlToRenderForLogo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }